import { render, staticRenderFns } from "./juegos_curso.vue?vue&type=template&id=67c18380"
import script from "./juegos_curso.vue?vue&type=script&lang=js"
export * from "./juegos_curso.vue?vue&type=script&lang=js"
import style0 from "./juegos_curso.vue?vue&type=style&index=0&id=67c18380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports